export enum CarDealershipSettingQueryKeys {
  GetList = 'getList'
}
